export default [
  {
    path: '/app/sectors',
    name: 'Sectors',
    component: () => import('@/views/Admin/Sectors/Index.vue'),
    meta: {
      pageTitle: 'Sektörler',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'ADMIN_SECTORS_LIST',
      action: 'read',
    },
  },
  {
    path: '/app/sectors/add',
    name: 'SectorsAdd',
    component: () => import('@/views/Admin/Sectors/Add.vue'),
    meta: {
      pageTitle: 'Sektörler',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/sectors',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'ADMIN_SECTORS_ADD',
      action: 'read',
    },
  },
  {
    path: '/app/sectors/edit/:id',
    name: 'Sectors',
    component: () => import('@/views/Admin/Sectors/Edit.vue'),
    meta: {
      pageTitle: 'Sektörler',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/sectors',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'ADMIN_SECTORS_LIST',
      action: 'read',
    },
  },
]
